export default __webpack_public_path__ + "static/12-settings-cd285e80373cebf71f7e48304f15664d.png";